import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/useAdminAuth';
import { CircularProgress, Box } from '@mui/material';

interface ProtectedRouteProps {
  children: ReactNode;
  requireSuper?: boolean;
}

/**
 * Protected Route 컴포넌트
 * 인증이 필요한 라우트를 보호하는 컴포넌트
 */
export const ProtectedRoute = ({ children, requireSuper = false }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, isSuper } = useAdminAuth();

  // 초기 인증 상태 확인 중이면 로딩 표시
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // 인증되지 않은 경우 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // SUPER 권한이 필요한 경우 권한 확인
  if (requireSuper && !isSuper) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <>{children}</>;
};
